jQuery(window).on('load', function(){
    if(document.getElementById('slidecarthq')){
        jQuery('#slidecarthq .slidecarthq button').prepend('<span class="sr-only">button</span>');
    }                                
});
jQuery(document).ready(function() {
    jQuery('.zoom-container img').attr('alt','zoomed image');
  	jQuery('.collectionBlock h4:empty').remove();
  	jQuery('label.icon-search').prepend('<span class="sr-only">search icon</span>').removeAttr('for');
  	jQuery('button.toggle-submenu').prepend('<span class="sr-only">toggle icon</span>');
    jQuery('button.nav-search-submit, button.signUp-submit').prepend('<span class="sr-only">submit</span>');
  	jQuery('a.nav-account-link').prepend('<span class="sr-only">user</span>');
  	jQuery('a.searchToggle').prepend('<span class="sr-only">search</span>');
    jQuery('a.cartTotal').prepend('<span class="sr-only">cart</span>');
  	jQuery('.nav-mobile-close').prepend('<span class="sr-only">close menu</span>');
    jQuery('button.js-cartToggle').prepend('<span class="sr-only">cart</span>');
    jQuery('.swatch-element label').prepend('<span class="sr-only">label</span>');
    jQuery('input#quantity').before('<label class="sr-only" for="quantity">quantity</label>');
    jQuery('.qty__adjust-btn').prepend('<span class="sr-only">adjust quantity</span>');
    jQuery('#slidecarthq .slidecarthq button').prepend('<span class="sr-only">button</span>');

  
  	setTimeout(function(){ 
       if(jQuery('#slidecarthq .slidecarthq button:empty')){
        jQuery('#slidecarthq .slidecarthq button').prepend('<span class="sr-only">button</span>');
       }
      jQuery('.zoom-container img').attr('alt','zoomed image');
    }, 3000);
    
    jQuery('.menuToggle').prepend('<span class="sr-only">menu opener</span>');
    jQuery('button.dropdown-arrow').prepend('<span class="sr-only">arrow</span>');
  
    var navOpen = false;
  
    
  jQuery('#hamburger-menu').click(function(e) {
    e.preventDefault();
     if(navOpen){
        jQuery(this).parent().attr('aria-expanded','false');
        navOpen = false;
       
      }else
        
      {jQuery(this).parent().attr('aria-expanded','true');
       navOpen = true;}
  });
  	
});